import { useEffect, useState } from "react";
import Cookies from "js-cookie";

export default function useLoanCreditReports(context) {
  const loanId = context?.loanId;
  const loanType = context?.loanType;
  const enabled = Boolean(loanId && ["personal", "corporate"].includes(loanType));
  const key = enabled ? `${loanType}:${loanId}` : null;
  const [state, setState] = useState({ key: null, reports: {}, loading: false, error: null });

  useEffect(() => {
    if (!enabled) return;
    const controller = new AbortController();
    let disposed = false;
    let timer;
    setState({ key, reports: {}, loading: true, error: null });
    const load = async () => {
      try {
        const response = await fetch(
          `https://www.smart-lend.com/api/loan/credit-reports?loan_type=${loanType}&loan_id=${encodeURIComponent(loanId)}`,
          { headers: { Authorization: `Bearer ${Cookies.get("token")}`, Accept: "application/json" }, signal: controller.signal },
        );
        if (!response.ok) throw new Error("Unable to load credit report analysis. Please reopen the profile to retry.");
        const reports = await response.json();
        if (disposed) return;
        setState({ key, reports, loading: false, error: null });
        if (Object.values(reports).some((report) => ["pending", "processing"].includes(report?.status))) {
          timer = setTimeout(load, 5000);
        }
      } catch (error) {
        if (!disposed) setState({ key, reports: {}, loading: false, error: error.message });
      }
    };
    load();
    return () => { disposed = true; controller.abort(); clearTimeout(timer); };
  }, [enabled, key, loanId, loanType]);

  // Never render results from the previously selected borrower, even for a single frame.
  return enabled && state.key === key ? state : { reports: {}, loading: enabled, error: null };
}
